import React from "react";

const SVGSortUnsorted = ({ color = "#071D49", size = 16, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M5.5 10L8 12.5L10.5 10M5.5 6L8 3.5L10.5 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGSortUnsorted;
